import { LocalStorageHandler } from './LocalStorageHandler';
import { UserState } from '../data/UserState';

export class StorageService {
	private _localStorageHandler: LocalStorageHandler;

	constructor() {
		this._initLocalStorageHandler();
	}

	private _initLocalStorageHandler() {
		this._localStorageHandler = new LocalStorageHandler();
	}

	get localStorageHandler() {
		return this._localStorageHandler;
	}

	readUserState(): UserState | undefined {
		return this.localStorageHandler.readUserState();
	}

	getInitialUserState(): UserState {
		return this.localStorageHandler.getNewUserState();
	}

	saveUserState(userState: UserState) {
		this.localStorageHandler.saveUserState(userState);
	}
}
